import { Box, Checkbox, Typography, Link } from '@mui/material';

/**
 * SMS consent (Twilio A2P 10DLC) notice.
 *
 * The checkbox is always checked and cannot be toggled off — consent is
 * required to submit either form. It deliberately renders as a normal,
 * checked checkbox (NOT the greyed-out MUI `disabled` state) by keeping the
 * input read-only and disabling pointer events on the control itself. The
 * surrounding text — including the Privacy Policy link — stays selectable and
 * clickable.
 *
 * Language mirrors the asilo-tour-widget consent copy verbatim so the messaging
 * stays consistent across the embeddable widget and the main website.
 */
function SmsConsentCheckbox() {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 1,
                mt: 2,
                mb: 1,
                textAlign: 'left',
            }}
        >
            <Checkbox
                checked
                disableRipple
                tabIndex={-1}
                color="primary"
                onClick={(e) => e.preventDefault()}
                inputProps={{
                    readOnly: true,
                    'aria-label': 'I agree to receive text messages from Asilo',
                }}
                sx={{
                    pointerEvents: 'none',
                    p: 0,
                    mt: '2px',
                    flexShrink: 0,
                }}
            />
            <Typography
                variant="body2"
                sx={{ fontSize: '0.75rem', lineHeight: 1.4, color: 'text.secondary' }}
            >
                I agree to receive text messages about my request,
                including confirmations and reminders. Message frequency varies. Msg &amp; data rates
                may apply. Reply STOP to opt out, HELP for help. See our{' '}
                <Link
                    href="https://www.prodigylearn.com/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ color: 'inherit' }}
                >
                    Privacy Policy
                </Link>
                .
            </Typography>
        </Box>
    );
}

export default SmsConsentCheckbox;
